import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Card, Message } from "shared/components";
import { VenueBlockForm } from "Bands/containers";
import { Venue } from "shared/assets/icons";
import { copy } from "shared/assets";
import { useEventContext } from "Bands/contexts";
import { IAPIState, IStatus } from "shared/types";
import { Spacer } from "shared/layout";
import { dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS, EventUniqueBlocks } from "Bands/types";
import { useClearActionMetaOnUnMount, useEventRoute } from "Bands/utils";
import { addTemporaryToast } from "shared/components/Toast";
import { BAND_PATHS } from "Bands/router";

const venueBlockCopy = copy.venueBlock;

export const CreateEventVenueBlockPage: FC = () => {
  const { hasBlocks } = useEventContext();
  const dispatch = useDispatch();
  const { pushRoute } = useEventRoute();

  const { api: apiMeta, id: createdBlockId } = useSelector(
    dataMetaSelector(BAND_ACTIONS.createEventVenueBlock)
  );
  useClearActionMetaOnUnMount(BAND_ACTIONS.createEventVenueBlock);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded && createdBlockId) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: venueBlockCopy.messages.created,
        })
      );

      pushRoute(BAND_PATHS.BAND_EVENT, { hash: createdBlockId });
    }
  }, [apiMeta?.status, createdBlockId, dispatch, pushRoute]);

  return (
    <Card title={venueBlockCopy.create.title} icon={Venue}>
      <Spacer size="m">
        {hasBlocks?.[EventUniqueBlocks.venue] && (
          <Message
            message={venueBlockCopy.messages.alreadyCreated}
            status={IStatus.error}
          />
        )}
        {!hasBlocks?.[EventUniqueBlocks.venue] && (
          <VenueBlockForm title={venueBlockCopy.title} />
        )}
      </Spacer>
    </Card>
  );
};
